import jQuery from 'jquery'
import moment from 'moment'
import 'bootstrap-datepicker'
import 'bootstrap-datepicker/dist/locales/bootstrap-datepicker.ru.min'

const $ = jQuery

export default {
  name: 'datepicker',
  props: {
    value: {
      type: [Date, String],
      default: new Date()
    },
    startDate: {
      type: [Date, String, Number],
      default: null
    },
    endDate: {
      type: [Date, String, Number],
      default: null
    }
  },
  mounted: function () {
    const self = this
    $(this.$el.getElementsByClassName('form-control'))
      .datepicker({
        language: 'ru',
        autoclose: true,
        todayHighlight: true,
        format: 'dd-mm-yyyy',
        startDate: this.startDate
          ? this.startDate
          : moment(this.value, 'DD-MM-YYYY').toDate() < new Date()
            ? moment(this.value, 'DD-MM-YYYY').toDate()
            : '0d',
        endDate: this.endDate ? this.endDate : Infinity
      })
      .datepicker('update', this.value || new Date())
      .on('change', function () {
        self.$emit('input', this.value)
      })
      .trigger('change')
  },
  methods: {
    proxyClick () {
      $(this.$el.getElementsByClassName('form-control')).datepicker('show')
    }
  },
  watch: {
    value: function (value) {
      // update value
      $(this.$el.getElementsByClassName('form-control'))
        .val(value)
        .trigger('change')
    }
  },
  destroyed: function () {
    $(this.$el.getElementsByClassName('form-control'))
      .off()
      .datepicker('destroy')
  }
}
